import PageHero from '../components/PageHero';
import { heroSubtitleClass, heroTitleClass, motionSafe } from '../constants/heroTypography';
import heroBg from '../assets/img/ic_our_service_background.png';
import { useEffect, useState } from 'react';

import ev1 from '../assets/img/gallery/ev1.jpeg';
import ev2 from '../assets/img/gallery/ev2.jpeg';
import ev3 from '../assets/img/gallery/ev3.jpeg';
import ev4 from '../assets/img/gallery/ev4.jpeg';
import ev5 from '../assets/img/gallery/ev5.jpeg';
import ev6 from '../assets/img/gallery/ev6.jpeg';
import ev7 from '../assets/img/gallery/ev7.jpeg';
import ev8 from '../assets/img/gallery/ev8.jpeg';
import ev9 from '../assets/img/gallery/ev9.jpeg';
import ev10 from '../assets/img/gallery/ev10.jpeg';
import ev11 from '../assets/img/gallery/ev11.jpeg';
import ev12 from '../assets/img/gallery/ev12.jpeg';
import ev13 from '../assets/img/gallery/ev13.jpeg';
import ev14 from '../assets/img/gallery/ev14.jpeg';
import ev15 from '../assets/img/gallery/ev15.jpeg';
import ev16 from '../assets/img/gallery/ev16.jpeg';
import ev17 from '../assets/img/gallery/ev17.jpeg';
import ev18 from '../assets/img/gallery/ev18.jpeg';
import ev19 from '../assets/img/gallery/ev19.jpeg';
import ev20 from '../assets/img/gallery/ev20.jpeg';
import kerala1 from '../assets/img/gallery/event_Kerala_Catholic_associations/1.jpeg';
import kerala2 from '../assets/img/gallery/event_Kerala_Catholic_associations/2.jpeg';
import kerala3 from '../assets/img/gallery/event_Kerala_Catholic_associations/3.jpeg';
import kerala4 from '../assets/img/gallery/event_Kerala_Catholic_associations/4.jpeg';
import kerala6 from '../assets/img/gallery/event_Kerala_Catholic_associations/6.jpeg';
import vq1 from '../assets/img/gallery/event_video/vq1.mp4';
import vq2 from '../assets/img/gallery/event_video/vq2.mp4';
import vq3 from '../assets/img/gallery/event_video/vq3.mp4';
import vq4 from '../assets/img/gallery/event_video/vq4.mp4';

const eventItems = [
  { src: ev1, alt: 'Event photo 1' },
  { src: ev2, alt: 'Event photo 2' },
  { src: ev3, alt: 'Event photo 3' },
  { src: ev4, alt: 'Event photo 4' },
  { src: ev5, alt: 'Event photo 5' },
  { src: ev6, alt: 'Event photo 6' },
  { src: ev7, alt: 'Event photo 7' },
  { src: ev9, alt: 'Event photo 8' },
  { src: ev11, alt: 'Event photo 9' },
  { src: ev12, alt: 'Event photo 10' },
  { src: ev13, alt: 'Event photo 11' },
  { src: ev14, alt: 'Event photo 12' },
  { src: ev15, alt: 'Event photo 13' },
  { src: ev16, alt: 'Event photo 14' },
  { src: ev17, alt: 'Event photo 15' },
  { src: ev18, alt: 'Event photo 16' },
  { src: ev20, alt: 'Event photo 17' },
];

const keralaItems = [
  { src: kerala1, alt: 'Kerala Catholic Associations — Event photo 1' },
  { src: kerala2, alt: 'Kerala Catholic Associations — Event photo 2' },
  { src: kerala3, alt: 'Kerala Catholic Associations — Event photo 3' },
  { src: kerala4, alt: 'Kerala Catholic Associations — Event photo 4' },
  { src: kerala6, alt: 'Kerala Catholic Associations — Event photo 6' },
];

const videoItems = [
  { src: vq1, title: 'Event video 1' },
  { src: vq2, title: 'Event video 2' },
  { src: vq3, title: 'Event video 3' },
  { src: vq4, title: 'Event video 4' },
];

export default function Gallery() {
  const [activeTab, setActiveTab] = useState('event'); // 'event' | 'kerala' | 'video'
  const [viewerOpen, setViewerOpen] = useState(false);
  const [viewerIndex, setViewerIndex] = useState(0);
  const [videoOpen, setVideoOpen] = useState(false);
  const [videoIndex, setVideoIndex] = useState(0);

  const items =
    activeTab === 'event' ? eventItems : activeTab === 'kerala' ? keralaItems : [];

  useEffect(() => {
    setViewerOpen(false);
    setViewerIndex(0);
    setVideoOpen(false);
    setVideoIndex(0);
  }, [activeTab]);

  function openViewer(idx) {
    setViewerIndex(idx);
    setViewerOpen(true);
  }

  function closeViewer() {
    setViewerOpen(false);
  }

  function prev() {
    setViewerIndex((i) => (i - 1 + items.length) % items.length);
  }

  function next() {
    setViewerIndex((i) => (i + 1) % items.length);
  }

  function openVideo(idx) {
    setVideoIndex(idx);
    setVideoOpen(true);
  }

  function closeVideo() {
    setVideoOpen(false);
  }

  function prevVideo() {
    setVideoIndex((i) => (i - 1 + videoItems.length) % videoItems.length);
  }

  function nextVideo() {
    setVideoIndex((i) => (i + 1) % videoItems.length);
  }

  useEffect(() => {
    if (!viewerOpen) return undefined;

    const onKeyDown = (e) => {
      if (e.key === 'Escape') closeViewer();
      if (e.key === 'ArrowLeft') setViewerIndex((i) => (i - 1 + items.length) % items.length);
      if (e.key === 'ArrowRight') setViewerIndex((i) => (i + 1) % items.length);
    };

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [items.length, viewerOpen]);

  useEffect(() => {
    if (!videoOpen) return undefined;

    const onKeyDown = (e) => {
      if (e.key === 'Escape') closeVideo();
      if (e.key === 'ArrowLeft') prevVideo();
      if (e.key === 'ArrowRight') nextVideo();
    };

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [videoOpen]);

  return (
    <div className="bg-navy-950">
      <PageHero
        title={
          activeTab === 'event'
            ? 'Event'
            : activeTab === 'kerala'
              ? 'Kerala Catholic Associations'
              : 'Event Video'
        }
        subtitle={
          activeTab === 'event'
            ? 'Event gallery highlights'
            : activeTab === 'kerala'
              ? 'Kerala Catholic Associations gallery highlights'
              : 'Event videos'
        }
        backgroundImage={heroBg}
        titleClassName={heroTitleClass}
        subtitleClassName={heroSubtitleClass(motionSafe)}
      />

      <section className="mx-auto max-w-7xl px-4 py-14 sm:px-6 sm:py-16 lg:px-8">
        <div className="mx-auto max-w-5xl">
          <div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
            <div className="inline-flex rounded-2xl border border-white/10 bg-white/5 p-1 shadow-lg shadow-black/20 ring-1 ring-gold/10">
              {[
                { id: 'event', label: 'Event' },
                { id: 'kerala', label: 'Kerala Catholic Associations' },
                { id: 'video', label: 'Event Video' },
              ].map((t) => {
                const isActive = activeTab === t.id;
                return (
                  <button
                    key={t.id}
                    type="button"
                    onClick={() => setActiveTab(t.id)}
                    className={`rounded-xl px-4 py-2 text-xs font-semibold uppercase tracking-[0.18em] transition sm:text-sm ${
                      isActive ? 'bg-gold text-navy shadow-sm' : 'text-white/80 hover:bg-white/10 hover:text-white'
                    }`}
                    aria-pressed={isActive}
                  >
                    {t.label}
                  </button>
                );
              })}
            </div>

            <div className="text-xs text-white/60">
              {activeTab === 'video' ? `${videoItems.length} videos` : `${items.length} photos`}
            </div>
          </div>
        </div>

        {activeTab === 'video' ? (
          <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {videoItems.map((v, idx) => (
              <figure
                key={v.src}
                className="group overflow-hidden rounded-2xl border border-white/10 bg-white/5 shadow-lg shadow-black/20 ring-1 ring-gold/10"
              >
                <button
                  type="button"
                  className="relative block w-full text-left"
                  onClick={() => openVideo(idx)}
                  aria-label={`Open video: ${v.title}`}
                >
                  <video
                    src={v.src}
                    className="h-56 w-full object-cover sm:h-64"
                    preload="metadata"
                    muted
                    playsInline
                  />
                  <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/55 via-transparent to-transparent" aria-hidden />
                  <div className="pointer-events-none absolute left-3 top-3 inline-flex items-center gap-2 rounded-full bg-black/40 px-3 py-1 text-xs font-semibold text-white ring-1 ring-white/10">
                    <span className="h-2 w-2 rounded-full bg-gold" aria-hidden />
                    VIDEO
                  </div>
                  <div className="pointer-events-none absolute inset-0 flex items-center justify-center" aria-hidden>
                    <span className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-black/45 ring-1 ring-white/15 backdrop-blur-sm">
                      <svg className="h-6 w-6 text-white" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M8 5v14l11-7z" />
                      </svg>
                    </span>
                  </div>
                </button>
                <figcaption className="px-4 py-3 text-sm text-white/75">
                  <span className="font-semibold text-gold">•</span> {v.title}
                </figcaption>
              </figure>
            ))}
          </div>
        ) : (
          <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {items.map((it, idx) => (
              <figure
                key={it.src}
                className="group overflow-hidden rounded-2xl border border-white/10 bg-white/5 shadow-lg shadow-black/20 ring-1 ring-gold/10"
              >
                <button
                  type="button"
                  className="block w-full text-left"
                  onClick={() => openViewer(idx)}
                  aria-label={`Open image: ${it.alt}`}
                >
                  <img
                    src={it.src}
                    alt={it.alt}
                    loading="lazy"
                    className="h-56 w-full object-cover transition duration-500 group-hover:scale-[1.03] sm:h-64"
                  />
                </button>
                <figcaption className="px-4 py-3 text-sm text-white/75">
                  <span className="font-semibold text-gold">•</span> {it.alt}
                </figcaption>
              </figure>
            ))}
          </div>
        )}
      </section>

      {viewerOpen ? (
        <div
          className="fixed inset-0 z-[60] flex items-center justify-center bg-black/80 p-4 backdrop-blur-sm"
          role="dialog"
          aria-modal="true"
          aria-label="Image viewer"
          onMouseDown={(e) => {
            if (e.target === e.currentTarget) closeViewer();
          }}
        >
          <div className="relative w-full max-w-5xl overflow-hidden rounded-2xl border border-white/10 bg-navy-950 shadow-2xl shadow-black/50 ring-1 ring-gold/15">
            <div className="flex items-center justify-between gap-3 border-b border-white/10 px-4 py-3">
              <p className="truncate text-sm font-semibold text-white/90">
                {items[viewerIndex]?.alt ?? 'Image'}
              </p>
              <button
                type="button"
                onClick={closeViewer}
                className="inline-flex h-9 w-9 items-center justify-center rounded-lg text-white/80 transition hover:bg-white/10 hover:text-white"
                aria-label="Close viewer"
              >
                <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <div className="relative bg-black/20">
              <img
                src={items[viewerIndex]?.src}
                alt={items[viewerIndex]?.alt ?? 'Image'}
                className="mx-auto max-h-[78vh] w-full object-contain"
              />

              <button
                type="button"
                onClick={prev}
                className="absolute left-3 top-1/2 -translate-y-1/2 inline-flex h-11 w-11 items-center justify-center rounded-full border border-white/10 bg-black/30 text-white/90 shadow-lg shadow-black/40 transition hover:bg-black/45"
                aria-label="Previous image"
              >
                <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
                </svg>
              </button>

              <button
                type="button"
                onClick={next}
                className="absolute right-3 top-1/2 -translate-y-1/2 inline-flex h-11 w-11 items-center justify-center rounded-full border border-white/10 bg-black/30 text-white/90 shadow-lg shadow-black/40 transition hover:bg-black/45"
                aria-label="Next image"
              >
                <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                </svg>
              </button>
            </div>

            <div className="flex items-center justify-between gap-3 px-4 py-3 text-xs text-white/60">
              <span>
                {viewerIndex + 1} / {items.length}
              </span>
              <span className="hidden sm:inline">Use ← → keys · Esc to close</span>
            </div>
          </div>
        </div>
      ) : null}

      {videoOpen ? (
        <div
          className="fixed inset-0 z-[60] flex items-center justify-center bg-black/80 p-4 backdrop-blur-sm"
          role="dialog"
          aria-modal="true"
          aria-label="Video viewer"
          onMouseDown={(e) => {
            if (e.target === e.currentTarget) closeVideo();
          }}
        >
          <div className="relative w-full max-w-5xl overflow-hidden rounded-2xl border border-white/10 bg-navy-950 shadow-2xl shadow-black/50 ring-1 ring-gold/15">
            <div className="flex items-center justify-between gap-3 border-b border-white/10 px-4 py-3">
              <p className="truncate text-sm font-semibold text-white/90">
                {videoItems[videoIndex]?.title ?? 'Video'}
              </p>
              <button
                type="button"
                onClick={closeVideo}
                className="inline-flex h-9 w-9 items-center justify-center rounded-lg text-white/80 transition hover:bg-white/10 hover:text-white"
                aria-label="Close viewer"
              >
                <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <div className="relative bg-black/20">
              <video
                src={videoItems[videoIndex]?.src}
                className="mx-auto max-h-[78vh] w-full"
                controls
                autoPlay
                playsInline
              />

              <button
                type="button"
                onClick={prevVideo}
                className="absolute left-3 top-1/2 -translate-y-1/2 inline-flex h-11 w-11 items-center justify-center rounded-full border border-white/10 bg-black/30 text-white/90 shadow-lg shadow-black/40 transition hover:bg-black/45"
                aria-label="Previous video"
              >
                <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
                </svg>
              </button>

              <button
                type="button"
                onClick={nextVideo}
                className="absolute right-3 top-1/2 -translate-y-1/2 inline-flex h-11 w-11 items-center justify-center rounded-full border border-white/10 bg-black/30 text-white/90 shadow-lg shadow-black/40 transition hover:bg-black/45"
                aria-label="Next video"
              >
                <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                </svg>
              </button>
            </div>

            <div className="flex items-center justify-between gap-3 px-4 py-3 text-xs text-white/60">
              <span>
                {videoIndex + 1} / {videoItems.length}
              </span>
              <span className="hidden sm:inline">Use ← → keys · Esc to close</span>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}
